module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD0SURBVHgB7ZiBCYNQDERj6QBuoiO4kbqJm6mbuMFvI1hskZpQ01O4ByklKPwHxhxm6YlcmJtcHAqgoQAaCqChwDeGYZgrlBRE0zS64efS/1GECPR9/zr8UtqLIOQRmqbJ1DsCDjEaCqChABoKoLl7LtZcY1lI4ziaelvkeS5lWYoZ68peZ5vo8mQnk8BWtokua3a6/Ayc8hGq69p6rJTpjxixDrFe17btW6/rOimKYvde7xC73kKut8MHeviqquRouMjQUAANBdBQAE2IgG5TS+8QUhDr7OTJNl5cWcjL8mH3lwiyR6jAP+AQo6EAGgqgoQCaB8Ham++eKf05AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/model-follow-black.png
// module id = tANW
// module chunks = 36